export default {
    accessControlList: [],
    controlAccessType: [],
    bookings: [],
    maintenanceRequestsList: [],
}